import { Author, PostOrPage, PostsOrPages, Tag } from '@tryghost/content-api';

// Helpers
import { normalizedImageUrl } from '../../images';
import { BrowseResults, GhostAuthors, GhostTags, NextImage } from './ghost-interfaces';

export const createNextImage = async (url?: string | null): Promise<NextImage | undefined> => {
    if (!url) return undefined;
    const normalizedUrl = await normalizedImageUrl(url);
    // const dimensions = await imageDimensions(normalizedUrl)
    const dimensions = { width: 0, height: 0 };
    return (dimensions && { url: normalizedUrl, dimensions }) || undefined;
};

export const createNextFeatureImages = async (
    nodes: BrowseResults<Tag | PostOrPage>
): Promise<GhostTags | PostsOrPages> => {
    const { meta } = nodes;
    const images = await Promise.all(nodes.map(node => createNextImage(node.feature_image)));
    const results = nodes.map((node, i) => ({ ...node, ...(images[i] && { featureImage: images[i] }) }));
    return Object.assign(results, { meta });
};

export const createNextProfileImages = async (nodes: BrowseResults<Author>): Promise<GhostAuthors> => {
    const { meta } = nodes;
    const images = await Promise.all(nodes.map(node => createNextImage(node.profile_image)));
    const results = nodes.map((node, i) => ({ ...node, ...(images[i] && { profileImage: images[i] }) }));
    return Object.assign(results, { meta });
};

export const createNextProfileImagesFromAuthors = async (
    nodes: Author[] | undefined
): Promise<Author[] | undefined> => {
    if (!nodes) return undefined;

    const images: NextImage[] = [];
    for (const node of nodes) {
        const image = await createNextImage(node.profile_image);
        if (image) {
            images.push(image);
        }
    }
    return nodes.map((node, i) => ({ ...node, ...(images[i] && { profileImage: images[i] }) }));
};

export const createNextProfileImagesFromPosts = async (nodes: BrowseResults<PostOrPage>): Promise<PostsOrPages> => {
    const { meta } = nodes;

    const authors = await Promise.all(nodes.map(node => createNextProfileImagesFromAuthors(node.authors)));
    const results = nodes.map((node, i) => ({ ...node, ...(authors[i] && { authors: authors[i] }) }));
    return Object.assign(results, { meta });
};
